import React, { PureComponent } from "react";
// reactstrap components
import {
	Button,
	Card,
	CardBody,
	CardHeader,
	CardTitle,
	Row,
	Col,
	FormGroup,
	Label,
	Input,
	Alert
} from "reactstrap";
import Datetime from "react-datetime";
import { startCase } from 'lodash';
import moment from 'moment';
import Async from 'react-select/async';

// Requests
import { getClientsRequest } from "api/client";
import { updateLetterRequest, createLetterRequest, getLetterRequest } from "api/letter";
import { getProjectsRequest } from "api/project";
import { getUsersRequest } from "api/user";
// Constants
import { letterStatuses } from "../../constants";
// Helpers
import { formatLetterType, formatLetterSubtype } from "helpers/letter";
import { getFormattedDate } from "helpers/date";
// Contexts
import ProjectContext from "contexts/ProjectContext";

class LetterForm extends PureComponent {

	constructor(props) {
		super(props);
		this.state = {
			letter: null,
			error: null,
			filters: {},
			filtersUser: {},
			statusWarning: false
		}
	}

	static contextType = ProjectContext

	async componentDidMount() {
		const params = new URLSearchParams(this.props.location.search);
		const id = params.get('id');

		if (id) {
			try {
				const letter = await getLetterRequest(id);
				console.log(letter)

				if(letter.project) {
					letter.selectedProject = {
						label: `${letter.project.name}`,
						value: letter.project._id
					};
				}
				if(letter.client) {
					letter.selectedClient = {
						label: `${letter.client.first_name} ${letter.client.last_name}`,
						value: letter.client._id
					};
				}
				if(letter.sent_by) {
					letter.selectedUser = {
						label: `${letter.sent_by.first_name} ${letter.sent_by.last_name}`,
						value: letter.sent_by._id
					};
				}
				this.setState({ letter })
			} catch(err) {
				this.setState({
					error: err.message || 'There was an error fetching payment'
				});
			}
		} else {
			// case for adding a letter
			this.goTo('/letters')
			/* this.setState({
				letter: {
					
				}
			}) */
		}
	}

	goTo = path => this.props.history.push(path);

	onChangeField = (e) => {
		const { target } = e;
		const { name, value } = target;

		const statusWarning = name === "status" && value ==="sent" ? true : false;

		this.setState(prevState => ({
			letter: {
				...prevState.letter,
				[name]: value,
			},
			statusWarning
		}));
	}

	save = async () => {
		this.setState({
			saving: true
		})

		const { letter } = this.state;
		const { _id } = letter;

		if(letter.selectedUser) {
			letter.sent_by = letter.selectedUser.value;
		}

		try {
			if (_id) {
				await updateLetterRequest(letter);
			} else {
				await createLetterRequest(letter);
			}
			this.setState({
				saving: false
			})
			this.goTo('/letters');
		} catch (err) {
			console.log(err, "error");
			this.setState({
				error: err.message || 'There was an error saving letter',
				saving: false
			})
		}
	}

	onSelectChange = (key) => (object) => {
		this.setState(prevState => ({
			letter: {
				...prevState.letter,
				[key]: object,
			},
		}));
	}

	loadClients = async (search, callback) => {
		const { filters } = this.state;
		const { selectedProject } = this.context

		filters.project = selectedProject

		if(search) {
			this.setState({
				filters: {
					...filters,
					search,
				},
			});

			const clientResponse = await getClientsRequest(filters);
			const clients = clientResponse.clients.map(client => {
				return {
					data: client,
					label: `${client.first_name} ${client.last_name}`,
					value: client._id
				}
			})
			callback(clients);
		}
	}

	loadProjects = async (search, callback) => {
		const { filtersProjects } = this.state;

		this.setState({
			filtersProjects: {
				...filtersProjects,
				search
			}
		})
		if(search) {
			const projectResponse = await getProjectsRequest(filtersProjects);
			const projects = projectResponse.projects.map(project => {
				return {
					data: project,
					label: `${project.name}`,
					value: project._id
				}
			})
			callback(projects);
		}
	}

	loadUsers = async (search, callback) => {
		const { filtersUser } = this.state;
		this.setState({
			filtersUser: {
				...filtersUser,
				search,
			},
		});
		if(search) {
			const usersResponse = await getUsersRequest(filtersUser);
			const users = usersResponse.users.map(user => {
				return {
					data: user,
					label: `${user.first_name} ${user.last_name}`,
					value: user._id
				}
			})
			callback(users);
		}
	}

	render() {

		const {
			letter = {},
			error = null,
			saving,
			statusWarning
		} = this.state;

		const {
			_id,
			status = '',
			selectedClient = [],
			selectedUser,
			send_date,
			sent_at,
			type,
			subtype,
			created_at,
			updated_at,
			postal_number,
			selectedProject
		} = letter || {};

		return (
			<>
				<div className="content">
					<Row>
						<Col md="12">
							<Card>
								<CardHeader className="mb-5">
									<CardTitle tag="h3">
										Letter
									</CardTitle>
									<Button
										className="float-right"
										color="default"
										onClick={() => this.goTo('/letters')}
									>
										Back
									</Button>
								</CardHeader>
								<CardBody>
									{!letter
										? <div>Loading...</div>
										: <>
												<FormGroup>
													<Label>Status</Label>
													<Input
														type="select"
														name="status"
														value={status || ''}
														onChange={this.onChangeField}
													>
														<option value="">--Select--</option>
														{
															letterStatuses.map(letterStatus => {
																return <option key={letterStatus} value={letterStatus}>{startCase(letterStatus)}</option>
															})
														}
													</Input>
												</FormGroup>
												{status === "sent" && statusWarning &&
													<Alert color="warning" fade={false}>
														Warning: Please use the "Mark letter as sent" modal 
														instead of setting the status as "Sent" directly on this page.
													</Alert>
												}
												<FormGroup>
													<Label>Sent At</Label>
													<Datetime
														inputProps={{
															className: "form-control",
															placeholder: "Send Date",
															name: "sent_at"
														}}
														dateFormat="MM/DD/YYYY"
														timeFormat={false}
														value={typeof sent_at === 'string' ? moment(sent_at).format("MM/DD/YYYY") : sent_at}
														onChange={(date) => this.onChangeField({target: { value: moment(date).format("MM/DD/YYYY"), name: "sent_at" }})}
														closeOnSelect={true}
													/>
												</FormGroup>
												<FormGroup>
													<Label>Send Date</Label>
													<Datetime
														inputProps={{
															className: "form-control",
															placeholder: "Send Date",
															name: "send_date"
														}}
														dateFormat="MM/DD/YYYY"
														timeFormat={false}
														value={typeof send_date === 'string' ? moment(send_date).format("MM/DD/YYYY") : send_date}
														onChange={(date) => this.onChangeField({target: { value: moment(date).format("MM/DD/YYYY"), name: "send_date" }})}
														closeOnSelect={true}
													/>
												</FormGroup>
												<FormGroup>
													<Label>Sent By</Label>
													<Async
														value={selectedUser}
														name="selectedUser"
														options={[]}
														loadOptions={this.loadUsers}
														className="basic-multi-select"
														classNamePrefix="select"
														onChange={this.onSelectChange('selectedUser')}
														placeholder="Search client by name or email"
													/>
												</FormGroup>
												{_id &&
													<>
														<FormGroup>
															<Label>Client</Label>
															<Async
																value={selectedClient}
																isDisabled
																name="selectedClient"
																options={[]}
																loadOptions={this.loadClients}
																className="basic-multi-select"
																classNamePrefix="select"
																onChange={this.onSelectChange('selectedClient')}
																placeholder="Search client by name or email"
															/>
														</FormGroup>
														<FormGroup>
															<Label>Project</Label>
															<Async
																value={selectedProject}
																name="selectedProject"
																options={[]}
																loadOptions={this.loadProjects}
																className="basic-multi-select"
																classNamePrefix="select"
																onChange={this.onSelectChange('selectedProject')}
																placeholder="Search project by name"
																isDisabled
															/>
														</FormGroup>
														<FormGroup>
															<Label>Type</Label>
															<Input
																type="text"
																readOnly
																name="type"
																value={formatLetterType(type) || ''}
																onChange={this.onChangeField}
															/>
														</FormGroup>
														<FormGroup>
															<Label>Sub Type</Label>
															<Input
																type="text"
																readOnly
																name="subtype"
																value={formatLetterSubtype(subtype) || ''}
																onChange={this.onChangeField}
															/>
														</FormGroup>
														<FormGroup>
															<Label>Postal Receipt Number</Label>
															<Input
																type="text"
																name="postal_number"
																value={postal_number}
																onChange={this.onChangeField}
															/>
														</FormGroup>
														<FormGroup>
															<Label>Created At</Label>
															<Input
																type="text"
																name="created_at"
																value={getFormattedDate(created_at || '')}
																readOnly
															/>
														</FormGroup>
														<FormGroup>
															<Label>Updated At</Label>
															<Input
																type="text"
																name="updated_at"
																value={getFormattedDate(updated_at || '')}
																readOnly
															/>
														</FormGroup>
													</>
												}
												</>}
									{error ? <div className="alert alert-danger mt-3">
										<span>{error}</span>
									</div> : null
									}
								</CardBody>
								{letter ? <Col>
									<Button color="primary" block={false} className="mb-4" onClick={this.save} disabled={saving}>
										{saving
											? "Saving..."
											: _id
												? "Save Changes"
												: "Save Letter"
										}
									</Button>
								</Col> : null}
							</Card>
						</Col>
					</Row>
				</div>
			</>
		)
	}
}

export default LetterForm;